export default function() {
    return {
        agencies: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {
            status: '1',
        },
        fields: [
            {
                key: 'id',
                label: 'ID'
            },
            {
                key: 'name',
                label: 'Agência'
            },
            {
                key: 'status',
                label: 'Ativa'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
